import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gerenciamientos',
  templateUrl: './gerenciamientos.component.html',
  styleUrl: './gerenciamientos.component.scss',
  standalone: false
})
export class GerenciamientosComponent {
  constructor(private router: Router) { }

  showDialogo: boolean = false;
  showPopover: boolean = false;

  abrirDialogo() {
    this.showDialogo = true;
  }

  toAdd() {
    this.router.navigate(['hse/gestionvehicular/add'])
  }

  // Función para controlar el estado del popover (activo-inactivo) y sincronizar con el blur de table
  togglePopover(event: MouseEvent, popover: any): void {
    if (this.showPopover) {
      popover.hide();
      this.showPopover = false;
    } else {
      popover.show(event);
      this.showPopover = true;
    }
  }

  datosTabla = [
    { id: 69380, origen: 'Ech-205 PAE', destino: 'BASE Z1', conductor: 'Alcala Juan', fechaPartida: '06/08/2025 - 07:50:00', fechaLlegada: '06/08/2025 - 08:30:00', estado: 'RETRASADO' },
    { id: 69375, origen: 'Base nqn', destino: 'Lc325', conductor: 'Galvan Julio Nestor', fechaPartida: '06/08/2025 - 06:00:00', fechaLlegada: '06/08/2025 - 07:45:00', estado: 'RETRASADO' },
    { id: 69374, origen: 'Base z1', destino: 'Phoenix hp230', conductor: 'Ravinale Emiliano', fechaPartida: '06/08/2025 - 05:06:00', fechaLlegada: '06/08/2025 - 07:06:00', estado: 'RETRASADO' },
    { id: 69357, origen: 'Base Comodoro Rivadavia', destino: 'PCG-1342 / DLC-333', conductor: 'Tapia Ricardo Osmar', fechaPartida: '05/08/2025 - 18:45:00', fechaLlegada: '05/08/2025 - 20:15:00', estado: 'RETRASADO' }
  ]

}
